import {
	Button,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	Typography,
} from "antd";

import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";

import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import { addSingleProject, loadAllProject } from "../../redux/rtk/features/projectManagement/project/project/project";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import PageTitle from "../page-header/PageHeader";
import Project from "./project";

const AddProject = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const userList = useSelector((state) => state?.users?.list);
	const { list=[] } = useSelector((state) => state?.project);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllStaff({ status: "true" }));
		dispatch(loadAllProject());
	}, []);

	const { Title } = Typography;
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		const projectData = {
			...values,
			startDate: dayjs(values.startDate).format(),
			endDate: dayjs(values.endDate).format(),
		};

		setLoader(true);
		const resp = await dispatch(addSingleProject(projectData));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding Project");
		setLoader(false);
	};

  return (
    <Fragment>
      <PageTitle title={"Back"} />
      <Row className="mr-top" gutter={[16, 16]} justify="space-between">
        {/* Left Column: Add Project Form */}
        <Col xs={24} sm={24} md={10} lg={10} xl={8} className="column-design border rounded card-custom">
          <Title level={4} className="m-2 mt-5 mb-5 text-center">
            Add New Project
          </Title>
          <Form
            form={form}
            style={{ marginBottom: "40px" }}
            name="project-form"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Project Manager"
              name="projectManagerId"
              rules={[{ required: true, message: "Select Project Manager" }]}
            >
              <Select
                loading={!userList.length}
                showSearch
                placeholder="Select Project Manager"
                optionFilterProp="children"
              >
                {(userList ?? []).map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.firstName} {item.lastName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Project Name"
              name="name"
              rules={[{ required: true, message: "Enter Project Name" }]}
            >
              <Input placeholder="Enter Project Name" />
            </Form.Item>

            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Please input Project Start Date!" }]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              label="End Date"
              name="endDate"
              rules={[{ required: true, message: "Please input Project End Date!" }]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Enter Project Description" }]}
            >
              <Input.TextArea placeholder="Enter Project Description" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 7, span: 16 }}>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                block
                loading={loader}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>

        {/* Right Column: Project List Table */}
        <Col xs={24} sm={24} md={14} lg={14} xl={16}>
          <Project />
        </Col>
      </Row>
    </Fragment>
  );
  
};

export default AddProject;
